<template>
    <v-dialog v-model="show" fullscreen transition="slide-y-transition" overlay-color="#111" overlay-opacity="0.95"
        :style="`${isAndroidNative ? 'margin-top: 100px; height: 100vh;' : ''} `">
        <v-card class="bg-dark pa-4 security-dialog">
            <v-btn variant="tonal" class="mt-6" @click="close"
                style="position: absolute; top: 12px; right: 12px; z-index: 10; transition: 0.3s ease;color: #fff;">

                {{ $t('closeButton') }}
            </v-btn>
            <div class="content-scroll">
                <h2 class="text-white mb-6 text-center font-weight-bold">
                    {{ $t('security.title') }}
                </h2>

                <!-- Visual Identity Flow -->
                <div class="d-flex flex-column align-center text-center mb-10" style="gap: 8px">
                    <v-icon size="36" color="white">mdi-account-lock</v-icon>
                    <span class="text-white font-weight-bold">{{ $t('security.user') }}</span>
                    <v-icon class="glow-arrow" size="28">mdi-arrow-down</v-icon>

                    <v-card class="flow-card">
                        <v-icon size="28" color="cyan">mdi-shield-account</v-icon>
                        <span class="text-white">{{ $t('security.authFlow') }}</span>
                    </v-card>

                    <v-icon class="glow-arrow" size="28">mdi-arrow-down</v-icon>

                    <v-card class="flow-card">
                        <v-icon size="28" color="cyan">mdi-database-lock</v-icon>
                        <span class="text-white">{{ $t('security.encryptionFlow') }}</span>
                    </v-card>
                </div>

                <!-- Compliance Cards -->
                <v-row justify="center" align="center" no-gutters>
                    <v-col v-for="item in $tm('security.cards')" :key="item.title" cols="12" sm="6" md="4" class="pa-2">
                        <v-card class="compliance-card">
                            <v-icon :color="item.color" size="32">{{ item.icon }}</v-icon>
                            <div class="text-white font-weight-bold mt-2">{{ item.title }}</div>
                            <ul class="text-white mt-2 bullet-list">
                                <li v-for="point in item.points" :key="point">{{ point }}</li>
                            </ul>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import { Capacitor } from '@capacitor/core';

const show = ref(false);
function open() { show.value = true; }
function close() { show.value = false; }
defineExpose({ open });
const isAndroidNative = Capacitor.getPlatform() === 'android' && Capacitor.isNativePlatform();

const cards = [
    {
        title: 'ISO Certifications',
        icon: 'mdi-certificate',
        color: 'green lighten-2',
        points: ['ISO 9001: Quality Management', 'ISO 27001: Information Security']
    },
    {
        title: 'GDPR Compliance',
        icon: 'mdi-shield-key',
        color: 'blue lighten-2',
        points: ['User consent & data rights', 'Secure data handling practices']
    },
    {
        title: 'Authentication Security',
        icon: 'mdi-fingerprint',
        color: 'deep-orange lighten-1',
        points: ['SSO integration', '2FA / Multi-Factor Authentication', 'Session protection']
    }
];
</script>

<style scoped>
.bg-dark {
    background-color: #111;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}


.security-dialog {
    width: 100%;
    max-width: 100vw;
    margin: 0 auto;
}

.close-btn {
    position: fixed;
    top: 12px;
    right: 12px;
    z-index: 100;
    background-color: #000000cc;
}

.content-scroll {
    width: 100%;
    max-width: 1100px;
    padding: 16px;
    padding-top: 64px;
    box-sizing: border-box;
}

.flow-card {
    background: #1e1e1e;
    padding: 14px;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 255, 255, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 260px;
    gap: 4px;
}

.glow-arrow {
    color: cyan;
    filter: drop-shadow(0 0 6px cyan);
}

.compliance-card {
    background-color: #1e1e1e;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 255, 255, 0.06);
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    min-height: 200px;
}

.compliance-card:hover {
    transform: scale(1.03);
    box-shadow: 0 8px 20px rgba(0, 255, 255, 0.12);
}

.bullet-list {
    text-align: left;
    font-size: 0.9rem;
    margin-top: 8px;
    padding-left: 16px;
    list-style: disc;
}

::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(0, 255, 255, 0.15);
    border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 255, 255, 0.3);
}

* {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 255, 255, 0.15) transparent;
}
</style>